import { Component, ViewChild } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';

import { HeaderComponent } from '../../shared/components/header/header.component';
import { SideComponent } from '../../shared/components/side/side.component';
import { FooterComponent } from '../../shared/components/footer/footer.component';

@Component({
    selector: 'app-main-layout',
    imports: [
        RouterOutlet,
        MatSidenavModule,
        HeaderComponent,
        SideComponent,
        FooterComponent,
    ],
    templateUrl: './main-layout.component.html',
    styleUrls: ['./main-layout.component.scss']
})
export class MainLayoutComponent {
  @ViewChild(MatSidenav) sidenav!: MatSidenav;

  isMobile = false;

  constructor(private breakpoint: BreakpointObserver) {
    this.breakpoint
      .observe([Breakpoints.Handset, Breakpoints.Tablet])
      .subscribe((r) => {
        this.isMobile = r.matches;
        if (!this.isMobile && this.sidenav) this.sidenav.open();
      });
  }

  toggleSidebar() {
    this.sidenav.toggle();
  }

  closeSidebarIfMobile() {
    if (this.isMobile) this.sidenav.close();
  }
}
